const PARTNER = {
    API: {
        REST: {
            BASE: 'https://pbx.sipcentric.com/api/v1',
            DEV_BASE: 'http://dev.voip123.co.uk/api/v1',
        },
    },
};
const authenticate = async (username, password, dev = false, params) => {
    // Base64 encode without btoa()
    const encodedCredentials = Buffer.from(`${username}:${password}`).toString('base64');
    const { cookieAuth, apiBase, partnerId } = params || {};
    const method = !cookieAuth ? 'POST' : 'GET';
    const headers = {
        //  disable authentication popup
        'X-WWW-Authenticate': 'false',
    };
    if (partnerId) {
        headers['X-Partner-Id'] = partnerId;
    }
    if (!cookieAuth) {
        headers.Authorization = `Basic ${encodedCredentials}`;
    }
    //  TODO get this from api
    const { REST } = PARTNER.API;
    let properApiBase = apiBase;
    if (!apiBase && apiBase !== '') {
        properApiBase = dev ? REST.DEV_BASE : REST.BASE;
    }
    try {
        const request = await fetch(`${properApiBase}/authenticate${cookieAuth ? '/verify' : ''}`, {
            credentials: 'include',
            method,
            headers,
        });
        //  Authentication successful
        if (request.status === 200) {
            const response = request.json();
            return response;
        }
        //  Authentication failed
        const response = request.text();
        return response;
    }
    catch (err) {
        //  failed fetch, user is offline
        return err instanceof Error ? err.toString() : String(err);
    }
};

export { authenticate as default };
//# sourceMappingURL=authenticate.js.map
